import { connect } from 'react-redux';

import { invoiceReportConfig } from '../../../entity/projects/invoiceReportConfig';
import BaseComponent from '../../../components/BaseComponent';

class InvoiceReports extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...invoiceReportConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(InvoiceReports);
